<template>
  <el-drawer
    title="配置关联方式与条件"
    direction="rtl"
    :visible.sync="dialogForm.visiable"
    @open="openDialog"
  >
    <div class="p-20px h-full">
      <div style="height: calc(100% - 56px)" class="overflow-auto">
        <div v-for="(item, index) in dialogForm.conditionList" :key="index">
          <div class="flex h-100px">
            <div class="text-14px w-80px">
              关联方式
              <el-tooltip placement="left">
                <div slot="content">
                  关联方式：是定义关联表的数据取值范围<br />
                  内部：等值连接， inner
                  join得出同时存在t1表和t2表的数据集，通俗一点说就是求两个表的交集。<br />
                  左侧：左连接从左表取出所有记录,与右表匹配。如果没有匹配，以null值代表右边表的列。outer可以不写，默认情况下不写outer关键字。<br />
                  右侧：右连接从右表取出所有记录，与左表匹配。如果没有匹配，以null值代表左边表的列。outer可以不写，默认情况下不写outer关键字。<br />
                  完全外部：两个表的并集，MySQL暂不支持这种语句，不过可以使用union将两个结果集“堆一起”，利用左连接，右连接分两次将数据取出，然后用union将数据合并去重。
                </div>
                <i class="iconfont icon-line-circleQuestion"></i>
              </el-tooltip>
            </div>
            <ul class="flex-1 flex ml-20px border divide-x text-12px">
              <li
                v-for="(mItem, mIndex) in methodList"
                :key="mIndex"
                class="w-1/4 flex flex-col p-10px"
                @click="changeMethods(mItem.value, index)"
                :class="mItem.value === item.associationType ? 'bg-[#e0f0fe]' : ''"
              >
                <div class="h-20px text-center">{{ mItem.name }}</div>
                <div class="flex-1 flex justify-center items-center">
                  <img :src="mItem.imgUrl" alt="" class="w-62px h-36px" />
                </div>
              </li>
            </ul>
          </div>
          <div class="flex mt-20px">
            <div class="text-14px w-80px">关联条件</div>
            <div class="flex-1 ml-20px text-12px">
              <div class="h-10px">
                <div class="bg-[#ffb029] h-10px w-200px float-left"></div>
                <div class="bg-[#ffb029] h-10px w-200px float-right"></div>
              </div>
              <div class="mt-10px h-30px flex">
                <div class="w-200px h-30px flex">
                  <img
                    src="../../../assets/images/table.png"
                    class="w-30px h-30px ml-10px"
                    alt=""
                  />
                  <div class="flex flex-col ml-10px">
                    <div>{{ item.table1Code }}</div>
                    <div class="mt-5px">{{ item.table1Name }}</div>
                  </div>
                </div>
                <div class="flex flex-col h-30px flex-1 pl-5px pr-5px">
                  <div class="bg-[#9a9a9a] h-5px w-full mt-5px"></div>
                  <div class="bg-[#9a9a9a] h-5px w-full mt-5px"></div>
                </div>
                <div class="w-200px h-30px flex">
                  <img
                    src="../../../assets/images/table.png"
                    class="w-30px h-30px ml-10px"
                    alt=""
                  />
                  <div class="flex flex-col ml-10px">
                    <div>{{ item.table2Code }}</div>
                    <div class="mt-5px">{{ item.table2Name }}</div>
                  </div>
                </div>
              </div>
              <div class="flex mt-10px">
                <div class="w-200px bg-[#eff1f7] p-10px">
                  <el-row>
                    <el-col
                      :span="24"
                      v-for="(cItem, cIndex) in item.conditions"
                      :key="cIndex"
                      :class="cIndex < item.conditions.length - 1 ? 'mb-10px' : ''"
                    >
                      <el-select v-model="cItem.sourceFieldId" clearable filterable size="mini">
                        <el-option
                          v-for="(aItem, aIndex) in item.table1AttributeList"
                          :key="aIndex"
                          :label="aItem.name"
                          :value="aItem.id"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <div class="flex-1 pt-46px pb-10px">
                  <div
                    class="h-36px flex justify-center items-center"
                    v-for="(cItem, cIndex) in item.conditions.length - 1"
                    :key="cIndex"
                    :class="cIndex < item.conditions.length - 1 ? 'mt-10px' : ''"
                    v-show="item.conditions.length > 1"
                  >
                    <el-tooltip placement="top" content="删除关联">
                      <div
                        class="w-20px h-20px rounded-1/2 bg-[#9a9a9a] text-[#fff] flex justify-center items-center cursor-pointer"
                        @click="addConditions('subtract', index, cIndex + 1)"
                      >
                        一
                      </div>
                    </el-tooltip>
                  </div>
                </div>
                <div class="w-200px bg-[#eff1f7] p-10px">
                  <el-row>
                    <el-col
                      :span="24"
                      v-for="(cItem, cIndex) in item.conditions"
                      :key="cIndex"
                      :class="cIndex < item.conditions.length - 1 ? 'mb-10px' : ''"
                    >
                      <el-select
                        v-model="cItem.targetFieldId"
                        clearable
                        filterable
                        size="mini"
                        @change="
                          changeTargetFieldId(
                            index,
                            cItem.targetFieldId,
                            cItem.sourceFieldId,
                            cIndex
                          )
                        "
                      >
                        <el-option
                          v-for="(aItem, aIndex) in item.table2AttributeList"
                          :key="aIndex"
                          :label="aItem.name"
                          :value="aItem.id"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="mt-10px text-color">
                <i
                  class="iconfont icon-line-circleAdd mr-10px"
                  @click="addConditions('add', index)"
                ></i
                >添加条件
              </div>
            </div>
          </div>
          <div class="w-full h-1px bg-[#9a9a9a] mt-10px mb-10px"></div>
        </div>
      </div>
      <div class="mt-20px text-center">
        <el-button type="primary" @click="confirmDialog">确定</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import stdClassListService from '@/services/stdClassListService'

export default {
  name: 'ConfigureRelationships',
  props: {
    dialogForm: {
      type: Object,
    },
  },
  data() {
    return {
      methodList: [
        {
          name: '内部',
          value: 0,
          imgUrl: require('../../../assets/images/inside.png'),
        },
        {
          name: '左侧',
          imgUrl: require('../../../assets/images/left-method.png'),
          value: 1,
        },
        {
          name: '右侧',
          imgUrl: require('../../../assets/images/right-method.png'),
          value: 2,
        },
        {
          name: '完全外部',
          imgUrl: require('../../../assets/images/outside.png'),
          value: 3,
        },
      ],
      tableList: [
        { table1: '', table2: '' },
        { table1: '', table2: '' },
      ],
    }
  },
  methods: {
    // 修改右侧targetFieldId
    changeTargetFieldId(i, targetFieldId, sourceFieldId, cIndex) {
      if (
        targetFieldId &&
        sourceFieldId &&
        this.dialogForm.conditionList[i].conditions.length > 1
      ) {
        _.map(this.dialogForm.conditionList[i].conditions, (item, index) => {
          if (
            targetFieldId === item.targetFieldId &&
            sourceFieldId === item.sourceFieldId &&
            cIndex !== index
          ) {
            this.$message.warning('不能选择相同的关联条件')
            this.dialogForm.conditionList[i].conditions[cIndex].targetFieldId = ''
          }
        })
      }
    },
    // 修改关联方式
    changeMethods(val, index) {
      this.dialogForm.conditionList[index].associationType = val
    },
    // 关闭对话框
    closeDialog() {
      this.dialogForm.visiable = false
    },
    // 添加关联条件
    addConditions(type, index, cIndex) {
      if (type === 'add') {
        this.dialogForm.conditionList[index].conditions.push({
          sourceFieldId: '',
          targetFieldId: '',
        })
      } else {
        this.dialogForm.conditionList[index].conditions.splice(cIndex, 1)
      }
    },
    // 获取属性列表
    async getAttributeList(classId) {
      const res = await stdClassListService.getAttrList({ class_id: classId })
      if (res && res.code === 0 && res.data) {
        const list = _.map(res.data, (item) => {
          return {
            code: item.code,
            name: item.name,
            id: item.id,
          }
        })
        return list
      }
      return []
    },
    // 打开对话框
    async openDialog() {
      // if (!this.dialogForm.isConfig || this.dialogForm.type === 'update') {
      //   const table1AttributeList = await this.getAttributeList(
      //     this.dialogForm.conditionList[0].table1Id
      //   )
      //   _.map(this.dialogForm.conditionList, async (item) => {
      //     item.table1AttributeList = table1AttributeList
      //     item.table2AttributeList = await this.getAttributeList(item.table2Id)
      //   })
      // }
    },
    // 点击确定按钮
    confirmDialog() {
      let totalList = []
      _.map(this.dialogForm.conditionList, (item) => {
        totalList = totalList.concat(item.conditions)
      })
      let flag = false
      _.map(totalList, (item) => {
        if (item.sourceFieldId === '' || item.targetFieldId === '') {
          flag = true
        }
      })
      if (flag) {
        this.$message.warning('关联条件不能为空')
        return
      }
      this.$emit('updateConfig', this.dialogForm.conditionList, this.dialogForm.rowIndex)
      this.closeDialog()
    },
  },
}
</script>

<style lang="scss" scoped>

.text-color {
  color: var(--systemMainColor);
}

</style>
